<template>
  <div>
    <slot name="title">
      <div class="text-body-2 text-secondary--text mb-3">
        {{ t('Стоимость приёма', options) }}
      </div>
    </slot>
    <div class="d-flex mx-n1">
      <PriceInput
        v-model="price.from"
        :max="price.to"
        :is-visible="isVisible"
        :placeholder="`0 ${currencySymbol}`"
        :autofocus="autofocus"
        :label="t('От', options)"
        class="w-100 px-1"
        @input="handleInput"
      />
      <PriceInput
        v-model="price.to"
        :min="price.from"
        :is-visible="isVisible"
        :label="t('До', options)"
        placeholder="∞"
        class="w-100 px-1"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { debounce } from 'www/utils'
import {
  computed,
  reactive,
  toRefs,
  watch,
} from 'vue'
import I18NextVue from 'i18next'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import PriceInput from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/FieldPrices/components/PriceInput.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const currencySymbol = window.CURRENCY_DATA.symbol

const emit = defineEmits(['input'])
const props = defineProps<{
  value: Filters,
  isVisible: boolean
  autofocus?: boolean
}>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const filtersStore = useFiltersStore()
const price = reactive<Filters['price']>({
  ...doctorFiltersState.value.price,
})

const emitChanges = () => {
  if (
    price.from === doctorFiltersState.value.price.from
    && price.to === doctorFiltersState.value.price.to
  ) {
    return
  }

  filtersStore.updateUnsavedFilters({
    ...doctorFiltersState.value,
    price: { ...price },
  })
  emit('input', {
    ...doctorFiltersState.value,
    price: { ...price },
  })
}

const debouncedEmitChanges = debounce(emitChanges, 700)

const handleInput = (newPrice?: number) => {
  if (newPrice === undefined) {
    emitChanges()

    return
  }

  debouncedEmitChanges()
}

watch(() => doctorFiltersState.value.price, async () => {
  if (price.from !== doctorFiltersState.value.price.from) {
    price.from = doctorFiltersState.value.price.from
  }

  if (price.to !== doctorFiltersState.value.price.to) {
    price.to = doctorFiltersState.value.price.to
  }
})
</script>
